import ImmutablePropTypes from 'react-immutable-proptypes';
import React from 'react';
import { Table } from '@bibliocommons/deprecated-base-table';

function MarcHoldingsTable({ rows }) {
  const eResourceMap = resources => (
    <ul>
      {resources.map(resource => (
        <li key={resource.get('url')}>
          <a href={resource.get('url')}>{resource.get('description')}</a>
        </li>
      ))}
    </ul>
  );

  return (
    <Table
      rows={rows}
      fields={[
        { key: 'location', type: 'location' },
        { key: 'collection', type: 'collection' },
        {
          key: 'format',
          type: 'format',
          localizationMap: value => `FORMAT.${value.toLowerCase()}`
        },
        { key: 'holdDuration', type: 'holdDuration' },
        { key: 'electronicResource', type: 'electronicResourcel', transformationMap: eResourceMap }
      ]}
    />
  );
}

MarcHoldingsTable.propTypes = {
  rows: ImmutablePropTypes.list.isRequired
};

export default MarcHoldingsTable;
